import { render, staticRenderFns } from "./PreBidsView.vue?vue&type=template&id=0d03c12c&scoped=true"
import script from "./PreBidsView.vue?vue&type=script&lang=js"
export * from "./PreBidsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03c12c",
  null
  
)

export default component.exports